import { ACTION, Answer, Question, QUESTION_TYPE, Reply, UiView, Value } from "./types"
import { languages } from "locales/languages"
import { cdn } from "core/cdn"
import {
  UPLOAD_DOC_PAGE,
  DERMATOSCOPE_VIDEO_PAGE,
  DERMATO_PHARMACIST_INFO_PAGE,
  DERMATO_RECAP_PAGE,
  TELEEXPERTISE_CONSENT_PAGE,
} from "core/constants"
import {
  allergy,
  drug,
  illness,
  operation,
  PATH,
  patient,
  exemption,
  selected_documents,
  pregnant,
  booleanReplies,
} from "./models"

export const dermato_upload_documents: Question = {
  id: PATH.upload_documents,
  title: languages.dermatoSelectedDocumentsTitle,
  multipleReplies: false,
  imgUrl: cdn("/images/dermatology_selected_documents_illustration.svg"),
  replies: [],
  // defaultReply: {
  //   title: languages.dermatoTakePhoto,
  //   action: ACTION.subquestion,
  //   value: true,
  //   ui: { view: "button", type: "primary" },
  // },
  defaultReply: {
    title: languages.dermatoTakePhoto,
    action: ACTION.redirect,
    ui: { type: "primary", view: "button" },
    value: `${UPLOAD_DOC_PAGE}?path=dermato`,
  },
  subquestion: selected_documents,
}

export const pimpleSubquestion: Question = {
  id: `${PATH.reason}:sub_pimple`,
  title: languages.dermatoSubReasonTitle,
  multipleReplies: true,
  ui: { view: "carousel" },
  replies: [
    {
      title: languages.dermatoPimpleAcne,
      value: "acne",
      imgUrl: cdn("/images/dermatology/sub_reasons/acne.svg"),
    },
    {
      title: languages.dermatoPimpleRecentlyAppeared,
      value: "recently_appeared",
      imgUrl: cdn("/images/dermatology/sub_reasons/recently_appeared.svg"),
    },
    {
      title: languages.dermatoPimplePersistentAndRecurrent,
      value: "persistent_and_recurrent",
      imgUrl: cdn("/images/dermatology/sub_reasons/persistent_and_recurrent.svg"),
    },
    {
      title: languages.dermatoPimplePainfulAndSwollen,
      value: "painful_and_swollen",
      imgUrl: cdn("/images/dermatology/sub_reasons/painful_and_swollen.svg"),
    },
    {
      title: languages.dermatoPimpleWithPus,
      value: "with_pus",
      imgUrl: cdn("/images/dermatology/sub_reasons/with_pus.svg"),
    },
    {
      title: languages.dermatoPimpleSubcutaneousCysts,
      value: "subcutaneous_cysts",
      imgUrl: cdn("/images/dermatology/sub_reasons/subcutaneous_cysts.svg"),
    },
  ],
}

const itchingSubquestion: Question = {
  id: `${PATH.reason}:sub_itching`,
  title: languages.dermatoSubReasonTitle,
  multipleReplies: true,
  ui: { view: "carousel" },
  replies: [
    {
      title: languages.dermatoItchingEczema,
      value: "eczema",
      imgUrl: cdn("/images/dermatology/sub_reasons/eczema.svg"),
    },
    {
      title: languages.itching_after_contact_with_a_product,
      value: "itching_after_contact_with_a_product",
      imgUrl: cdn("/images/dermatology/sub_reasons/itching_after_contact_with_a_product.svg"),
    },
    {
      title: languages.itching_on_dry_skin,
      value: "itching_on_dry_skin",
      imgUrl: cdn("/images/dermatology/sub_reasons/itching_on_dry_skin.svg"),
    },
    {
      title: languages.recurrent_itching,
      value: "recurrent_itching",
      imgUrl: cdn("/images/dermatology/sub_reasons/recurrent_itching.svg"),
    },
    {
      title: languages.itching_after_a_sting,
      value: "itching_after_a_sting",
      imgUrl: cdn("/images/dermatology/sub_reasons/itching_after_a_sting.svg"),
    },
    {
      title: languages.nightly_itching,
      value: "nightly_itching",
      imgUrl: cdn("/images/dermatology/sub_reasons/nightly_itching.svg"),
    },
  ],
}

const rashSubquestion: Question = {
  id: `${PATH.reason}:sub_rash`,
  title: languages.dermatoSubReasonTitle,
  multipleReplies: true,
  ui: { view: "carousel" },
  replies: [
    {
      title: languages.spread_out,
      value: "spread_out",
      imgUrl: cdn("/images/dermatology/sub_reasons/spread_out.svg"),
    },
    {
      title: languages.medication_with_eruption,
      value: "medication_with_eruption",
      imgUrl: cdn("/images/dermatology/sub_reasons/medication_with_eruption.svg"),
    },
    {
      title: languages.small_bumps_with_eruption,
      value: "small_bumps_with_eruption",
      imgUrl: cdn("/images/dermatology/sub_reasons/small_bumps_with_eruption.svg"),
    },
    {
      title: languages.scales_with_eruption,
      value: "scales_with_eruption",
      imgUrl: cdn("/images/dermatology/sub_reasons/scales_with_eruption.svg"),
    },
    {
      title: languages.sudden_eruption,
      value: "sudden_eruption",
      imgUrl: cdn("/images/dermatology/sub_reasons/sudden_eruption.svg"),
    },
    {
      title: languages.dermatoRashHerpes,
      value: "herpes",
      imgUrl: cdn("/images/dermatology/sub_reasons/herpes.svg"),
    },
  ],
}

const molesSubquestion: Question = {
  id: `${PATH.reason}:sub_moles`,
  title: languages.dermatoSubReasonTitle,
  multipleReplies: true,
  ui: { view: "carousel" },
  replies: [
    {
      title: languages.dermatoMolesSuspect,
      value: "suspect_beauty_spot",
      imgUrl: cdn("/images/dermatology/sub_reasons/suspect_beauty_spot.svg"),
    },
    {
      title: languages.dermatoMolesChangedShape,
      value: "changed_shape",
      imgUrl: cdn("/images/dermatology/sub_reasons/changed_shape.svg"),
    },
    {
      title: languages.dermatoMolesRecentlyIncreased,
      value: "recently_increased",
      imgUrl: cdn("/images/dermatology/sub_reasons/recently_increased.svg"),
    },
    {
      title: languages.dermatoMolesChangedColor,
      value: "changed_color",
      imgUrl: cdn("/images/dermatology/sub_reasons/changed_color.svg"),
    },
    {
      title: languages.dermatoMolesBleedingOrOozing,
      value: "bleeding_or_oozing",
      imgUrl: cdn("/images/dermatology/sub_reasons/bleeding_or_oozing.svg"),
    },
    {
      title: languages.dermatoDarkSpotAppearedRecently,
      value: "dark_spot_appeared_recently",
      imgUrl: cdn("/images/dermatology/sub_reasons/dark_spot_appeared_recently.svg"),
    },
  ],
}

const treatmentSubquestion: Question = {
  id: `${PATH.reason}:sub_treatment`,
  title: languages.dermatoSubReasonTitle,
  multipleReplies: true,
  ui: { view: "carousel", preventAddMore: true },
  replies: [
    {
      title: languages.dermatoTreatmentLessEffective,
      value: "treatment_became_less_effective",
      imgUrl: cdn("/images/dermatology/sub_reasons/treatment_became_less_effective.svg"),
    },
    {
      title: languages.dermatoTreatmentSkinReaction,
      value: "skin_reaction_since_beginning_of_treatment",
      imgUrl: cdn("/images/dermatology/sub_reasons/skin_reaction_since_beginning_of_treatment.svg"),
    },
    {
      title: languages.dermatoTreatmentIrritatedOrDrySkin,
      value: "irritated_or_dry_skin_since_beginning_of_treatment",
      imgUrl: cdn("/images/dermatology/sub_reasons/irritated_or_dry_skin_since_beginning_of_treatment.svg"),
    },
    {
      title: languages.dermatoTreatmentSymptomsReturned,
      value: "symptoms_returned_after_treatment_ended",
      imgUrl: cdn("/images/dermatology/sub_reasons/symptoms_returned_after_treatment_ended.svg"),
    },
    {
      title: languages.dermatoTreatmentDoubt,
      value: "doubt_about_treatment_use",
      imgUrl: cdn("/images/dermatology/sub_reasons/doubt_about_treatment_use.svg"),
    },
  ],
}

const otherSubquestion: Question = {
  id: `${PATH.reason}:sub_other`,
  title: languages.dermatoSubReasonTitle,
  multipleReplies: true,
  ui: { view: "carousel", preventAddMore: true },
  replies: [
    {
      title: languages.dermatoOtherUnusualHairLoss,
      value: "unusual_hair_loss",
      imgUrl: cdn("/images/dermatology/sub_reasons/unusual_hair_loss.svg"),
    },
    {
      title: languages.dermatoOtherNailPeelingOrThickeningOrColoring,
      value: "nail_peeling_or_thickening_or_coloring",
      imgUrl: cdn("/images/dermatology/sub_reasons/nail_peeling_or_thickening_or_coloring.svg"),
    },
    {
      title: languages.dermatoOtherVerrucousOrGrowthOnSkin,
      value: "verrucous_or_excroissance_on_the_skin",
      imgUrl: cdn("/images/dermatology/sub_reasons/verrucous_or_excroissance_on_the_skin.svg"),
    },
    {
      title: languages.dermatoOtherCicatriceChangedAppearance,
      value: "cicatrice_with_changed_appearance",
      imgUrl: cdn("/images/dermatology/sub_reasons/cicatrice_with_changed_appearance.svg"),
    },
    {
      title: languages.dermatoOtherWhiteOrDepigmentedSpot,
      value: "white_or_depigmented_spot",
      imgUrl: cdn("/images/dermatology/sub_reasons/white_or_depigmented_spot.svg"),
    },
  ],
}

const DERMATO_SUB_REASONS: Record<string, Question> = {
  [languages.dermatoReasonPimples]: pimpleSubquestion,
  [languages.dermatoReasonItching]: itchingSubquestion,
  [languages.dermatoReasonRash]: rashSubquestion,
  [languages.dermatoReasonMoles]: molesSubquestion,
  [languages.dermatoReasonTreatmentFollowup]: treatmentSubquestion,
  [languages.dermatoReasonOther]: otherSubquestion,
}

export const dermato_reason: Question = {
  id: PATH.reason,
  title: languages.anamneseReasonQuestion,
  multipleReplies: false,
  ui: { view: "carousel" },
  replies: [
    {
      title: languages.dermatoReasonPimples,
      value: languages.dermatoReasonPimples,
      imgUrl: cdn("/images/reasons/picto_boutons.svg"),
      action: ACTION.subquestion,
    },
    {
      title: languages.dermatoReasonItching,
      value: "Démangeaisons",
      imgUrl: cdn("/images/reasons/picto_demangeaisons.svg"),
      action: ACTION.subquestion,
    },
    {
      title: languages.dermatoReasonRash,
      value: "Éruptions cutanées",
      imgUrl: cdn("/images/reasons/picto_eruption_cutanee_body.svg"),
      action: ACTION.subquestion,
    },
    {
      title: languages.dermatoReasonMoles,
      value: "Grains de beauté et taches suspectes",
      imgUrl: cdn("/images/reasons/picto_points_noirs.svg"),
      action: ACTION.subquestion,
    },
    {
      title: languages.dermatoReasonTreatmentFollowup,
      value: "Suivi de traitement",
      imgUrl: cdn("/images/reasons/picto_suivi_de_traitement.svg"),
      action: ACTION.subquestion,
    },
    {
      title: languages.dermatoReasonOther,
      value: "Autres",
      imgUrl: cdn("/images/reasons/picto_autre.svg"),
      action: ACTION.subquestion,
    },
  ],
}

export const getDermatoSubReasonByValue = (value: string): Question | undefined => {
  const reply = dermato_reason.replies.find((r) => r.value === value)
  return reply ? DERMATO_SUB_REASONS[reply.title as string] : undefined
}

const ALL_DERMATO_SUB_QUESTIONS = Object.values(DERMATO_SUB_REASONS)

export const getDermatoSubReasonValue = (answers: Answer[]): Value | undefined => {
  const subAnswer = answers.find((a) =>
    a.questionId.startsWith(`${PATH.reason}:sub_`),
  )
  if (!subAnswer?.value?.length) return undefined

  const subQuestion = ALL_DERMATO_SUB_QUESTIONS.find(
    (q) => q.id === subAnswer.questionId,
  )
  const toLabel = (value: Value): string =>
    subQuestion?.replies.find((r) => r.value === value)?.title ?? String(value)

  if (subAnswer.value.length === 1) return toLabel(subAnswer.value[0])
  return subAnswer.value.map(toLabel).join(", ")
}

export const dermato_symptoms: Question = {
  id: PATH.dermato_symptoms,
  title: languages.dermatoSymptomsTitle,
  multipleReplies: true,
  allowSkip: false,
  ui: { view: "carousel", preventAddMore: true },
  replies: [
    {
      title: languages.noSymptoms,
      value: languages.noSymptoms,
      imgUrl: cdn("/images/reasons/picto_aucun.svg"),
    },
    {
      title: languages.dermatoSymptomFever,
      value: languages.dermatoSymptomFever,
      imgUrl: cdn("/images/reasons/picto_fievre.svg"),
    },
    {
      title: languages.dermatoSymptomSweat,
      value: languages.dermatoSymptomSweat,
      imgUrl: cdn("/images/reasons/picto_sueur.svg"),
    },
    {
      title: languages.dermatoSymptomPain,
      value: languages.dermatoSymptomPain,
      imgUrl: cdn("/images/reasons/picto_douleurs.svg"),
    },
    {
      title: languages.otherSymptoms,
      value: languages.otherSymptoms,
      imgUrl: cdn("/images/reasons/picto_autre.svg"),
    },
  ],
}

export const dermato_body_zone: Question = {
  id: PATH.dermato_body_zone,
  title: languages.dermatoBodyZoneTitle,
  multipleReplies: true,
  replies: [
    {
      title: languages.dermatoBodyZoneWholeBody,
      value: "Tout le corps",
      imgUrl: cdn("/images/dermatology/full_body.svg"),
    },
    {
      title: languages.dermatoBodyZoneChest,
      value: "Torse",
      imgUrl: cdn("/images/dermatology/body_part_chest.svg"),
    },
    {
      title: languages.dermatoBodyZoneBackBody,
      value: "Dos",
      imgUrl: cdn("/images/dermatology/body_part_back.svg"),
    },
    {
      title: languages.dermatoBodyZoneFace,
      value: "Visage",
      imgUrl: cdn("/images/dermatology/body_part_face.svg"),
    },
    {
      title: languages.dermatoBodyZoneHead,
      value: "Tête",
      imgUrl: cdn("/images/dermatology/body_part_head.svg"),
    },
    {
      title: languages.dermatoBodyZoneNeck,
      value: "Cou",
      imgUrl: cdn("/images/dermatology/body_part_neck.svg"),
    },
    {
      title: languages.dermatoBodyZoneHands,
      value: "Main(s)",
      imgUrl: cdn("/images/dermatology/body_part_hand.svg"),
    },
    {
      title: languages.dermatoBodyZoneFeet,
      value: "Pied(s)",
      imgUrl: cdn("/images/dermatology/body_part_foot.svg"),
    },
    {
      title: languages.dermatoBodyZoneArms,
      value: "Bras",
      imgUrl: cdn("/images/dermatology/body_part_arm.svg"),
    },
    {
      title: languages.dermatoBodyZoneLegs,
      value: "Jambe(s)",
      imgUrl: cdn("/images/dermatology/body_part_leg.svg"),
    },
    {
      title: languages.dermatoBodyZoneArmpits,
      value: "Aisselles",
      imgUrl: cdn("/images/dermatology/body_part_breast.svg"),
    },

    {
      title: languages.dermatoBodyZoneGenitals,
      value: "Parties génitales",
      imgUrl: cdn("/images/dermatology/body_part_sex.svg"),
    },

    {
      title: languages.dermatoBodyZoneButtocks,
      value: "Fesses",
      imgUrl: cdn("/images/dermatology/body_part_buttocks.svg"),
    },

    {
      title: languages.dermatoBodyZoneShoulders,
      value: "Epaule(s)",
      imgUrl: cdn("/images/dermatology/body_part_shoulder.svg"),
    },

    {
      title: languages.dermatoBodyZoneOther,
      value: "Autre",
      imgUrl: cdn("/images/reasons/picto_autre.svg"),
    },
  ],
}

export const dermato_phototype: Question = {
  id: PATH.dermato_phototype,
  title: languages.dermatoPhototypeTitle,
  multipleReplies: false,
  ui: { view: "carousel" },
  replies: [
    {
      title: languages.phototype1_html,
      value: {
        identifier: "phototype_1",
        label: languages.phototype1,
      },
      imgUrl: cdn("/images/dermatology/phototype_1.svg"),
    },
    {
      title: languages.phototype2_html,
      value: {
        identifier: "phototype_2",
        label: languages.phototype2,
      },
      imgUrl: cdn("/images/dermatology/phototype_2.svg"),
    },
    {
      title: languages.phototype3_html,
      value: {
        identifier: "phototype_3",
        label: languages.phototype3,
      },
      imgUrl: cdn("/images/dermatology/phototype_3.svg"),
    },
    {
      title: languages.phototype4_html,
      value: {
        identifier: "phototype_4",
        label: languages.phototype4,
      },
      imgUrl: cdn("/images/dermatology/phototype_4.svg"),
    },
    {
      title: languages.phototype5_html,
      value: {
        identifier: "phototype_5",
        label: languages.phototype5,
      },
      imgUrl: cdn("/images/dermatology/phototype_5.svg"),
    },
    {
      title: languages.phototype6_html,
      value: {
        identifier: "phototype_6",
        label: languages.phototype6,
      },
      imgUrl: cdn("/images/dermatology/phototype_6.svg"),
    },
  ],
}

export const dermato_video_capture: Question = {
  id: PATH.dermato_video_capture,
  title: languages.dermatoVideoCaptureTitle,
  multipleReplies: false,
  type: QUESTION_TYPE.redirect,
  replies: [],
  value: DERMATOSCOPE_VIDEO_PAGE,
}

// Questions dermatologiques spécifiques
const dermato_last_control: Question = {
  id: PATH.dermato_last_control,
  title: languages.dermatoLastControl,
  multipleReplies: false,
  imgUrl: cdn("/images/dermatology/last_control.svg"),
  replies: [
    {
      title: languages.dermatoLastControlLess3Years,
      value: "-3",
      ui: {
        view: "button",
      },
    },
    {
      title: languages.dermatoLastControlMore3Years,
      value: "+3",
      ui: {
        view: "button",
      },
    },
  ],
}

const dermato_sun_exposure: Question = {
  imgUrl: cdn("/images/dermatology/sun_exposure.svg"),
  id: PATH.dermato_sun_exposure,
  title: languages.dermatoSunExposure,
  multipleReplies: false,
  replies: booleanReplies,
}

const dermato_sun_protection: Question = {
  imgUrl: cdn("/images/dermatology/sun_protection.svg"),
  id: PATH.dermato_sun_protection,
  title: languages.dermatoSunProtection,
  multipleReplies: false,
  replies: booleanReplies,
}

const dermato_sunburn_before_20: Question = {
  imgUrl: cdn("/images/dermatology/sunburn_before_20.svg"),
  id: PATH.dermato_sunburn_before_20,
  title: languages.dermatoSunburnBefore20,
  multipleReplies: false,
  replies: booleanReplies,
}

const dermato_history: Question = {
  id: PATH.dermato_history,
  title: languages.dermatoHistory,
  multipleReplies: false,
  replies: booleanReplies,
  imgUrl: cdn("/images/dermatology/history.svg"),
}

export const dermato_history_details: Question = {
  id: PATH.dermato_history_details,
  title: languages.dermatoHistoryDetailsTitle,
  multipleReplies: true,
  ui: { view: "carousel" },
  replies: [
    {
      title: languages.dermatoHistorySkinCancer,
      value: "Cancer de la peau (mélanome, carcinome) — personnel ou familial",
    },
    {
      title: languages.dermatoHistoryEczema,
      value: "Eczéma (dermatite atopique)",
    },
    { title: languages.dermatoHistoryPsoriasis, value: "Psoriasis" },
    { title: languages.dermatoHistoryAcne, value: "Acné" },
    { title: languages.dermatoHistoryChronicHives, value: "Urticaire chronique" },
    {
      title: languages.dermatoHistoryHerpesZona,
      value: "Herpès / zona récidivant",
    },
    { title: languages.dermatoHistoryRosacea, value: "Rosacée" },
  ],
}

const dermato_family_cancer: Question = {
  id: PATH.dermato_family_cancer,
  title: languages.dermatoFamilyCancer,
  multipleReplies: false,
  replies: booleanReplies,
  imgUrl: cdn("/images/dermatology/family_cancer.svg"),
}

const dermato_recent_travel: Question = {
  id: PATH.dermato_recent_travel,
  title: languages.dermatoRecentTravel,
  multipleReplies: false,
  replies: booleanReplies,
  imgUrl: cdn("/images/dermatology/recent_travel.svg"),
}

const dermato_zone_evolution: Question = {
  id: PATH.dermato_zone_evolution,
  title: languages.dermatoZoneEvolution,
  multipleReplies: false,
  replies: booleanReplies,
  imgUrl: cdn("/images/dermatology/zone_evolution.svg"),
}

// Échelle de temps commune aux questions d'apparition / d'évolution de la lésion.
// Les valeurs sont les libellés français : elles sont transmises telles quelles
// au dermatologue (même logique que reason_details).
const dermatoDurationReplies: Reply[] = [
  { title: languages.dermatoDurationLessThan48h, value: languages.dermatoDurationLessThan48h },
  { title: languages.dermatoDuration2To7Days, value: languages.dermatoDuration2To7Days },
  { title: languages.dermatoDuration1WeekTo1Month, value: languages.dermatoDuration1WeekTo1Month },
  { title: languages.dermatoDuration1To6Months, value: languages.dermatoDuration1To6Months },
  { title: languages.dermatoDurationMoreThan6Months, value: languages.dermatoDurationMoreThan6Months },
]

export const dermato_problem_duration: Question = {
  id: PATH.dermato_problem_duration,
  title: languages.dermatoProblemDurationTitle,
  subtitle: languages.dermatoProblemDuration,
  subtitleCustomStyle: {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: "1.5",
  },
  multipleReplies: false,
  ui: { view: "slider" },
  replies: dermatoDurationReplies,
}

// Écran affiché uniquement si le patient a répondu OUI à dermato_zone_evolution
// (inséré / retiré dynamiquement par la saga).
export const dermato_zone_evolution_duration: Question = {
  id: PATH.dermato_zone_evolution_duration,
  title: languages.dermatoZoneEvolutionDurationTitle,
  subtitle: languages.dermatoZoneEvolutionDuration,
  subtitleCustomStyle: {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: "1.5",
  },
  multipleReplies: false,
  ui: { view: "slider" },
  replies: dermatoDurationReplies,
}

export const dermato_questions: Question & { questions: Question[] } = {
  id: PATH.dermato_questions,
  title: languages.dermatoQuestionsTitle,
  ui: { view: "questions_line" },
  questions: [
    dermato_last_control,
    dermato_sun_exposure,
    dermato_sun_protection,
    dermato_sunburn_before_20,
  ],
  replies: [],
  multipleReplies: true,
}

export const dermato_anamnesis_questions: Question & { questions: Question[] } =
{
  id: PATH.dermato_anamnesis_questions,
  title: languages.dermatoAnamnesisQuestionsTitle,
  ui: { view: "questions_line" },
  questions: [
    dermato_history,
    dermato_family_cancer,
    dermato_recent_travel,
    dermato_zone_evolution,
  ],
  replies: [],
  multipleReplies: true,
}

export const anamnesis_questions: Question & { questions: Question[] } = {
  id: PATH.anamnesis_questions,
  title: languages.anamnesisQuestionsTitle,
  ui: { view: "questions_line" },
  questions: [illness, operation, allergy, drug],
  replies: [],
  multipleReplies: true,
}

export const dermato_recap: Question = {
  id: PATH.dermato_recap,
  title: languages.dermatoRecapTitle,
  multipleReplies: false,
  type: QUESTION_TYPE.redirect,
  replies: [],
  value: DERMATO_RECAP_PAGE,
}

export const dermato_consent: Question = {
  id: PATH.dermato_consent,
  title: languages.teleexpertiseConsentTitle,
  multipleReplies: false,
  type: QUESTION_TYPE.redirect,
  replies: [],
  value: TELEEXPERTISE_CONSENT_PAGE,
}

const dermato_overview_part1: Question = {
  title: languages.dermatoOverviewPart1_html,
  titleCustomStyle: {
    fontSize: 48,
    fontWeight: 500,
    lineHeight: "1.5",
  },
  imgUrl: cdn("/images/dermatology/dermatologist.svg"),
  id: PATH.dermato_overview_part1,
  multipleReplies: false,
  replies: [],
  defaultReply: {
    ui: { type: "primary" },
    title: languages.continue,
    value: -1,
  },
}

const dermato_overview_info: Question = {
  title: languages.dermatoOverviewInfoTitle,
  id: PATH.dermato_overview_info,
  multipleReplies: false,
  replies: [],
  infoItems: [
    {
      imgUrl: cdn("/images/documents/expertise_icon.svg"),
      text: languages.dermatoOverviewInfoItem1_html,
    },
    {
      imgUrl: cdn("/images/dermatology/no_prescription.svg"),
      text: languages.dermatoOverviewInfoItem2_html,
    },
    {
      imgUrl: cdn("/images/dermatology/dermatologist_magnifier.svg"),
      text: languages.dermatoOverviewInfoItem3_html,
    },
  ],
  defaultReply: {
    ui: { type: "primary" },
    title: languages.continue,
    value: -1,
  },
}

const dermato_overview_part2: Question = {
  title: languages.dermatoOverviewPart2_html,
  titleCustomStyle: {
    fontSize: 48,
    fontWeight: 500,
    lineHeight: "1.5",
  },
  imgUrl: cdn("/images/picto_small_dispositif.svg"),
  id: PATH.dermato_overview_part2,
  multipleReplies: false,
  replies: [],
  defaultReply: {
    ui: { type: "primary" },
    title: languages.continue,
    value: -1,
  },
}

export const dermato_pharmacist_info: Question = {
  id: PATH.dermato_pharmacist,
  title: languages.pharmacistInfoTitle,
  multipleReplies: false,
  type: QUESTION_TYPE.redirect,
  replies: [],
  value: DERMATO_PHARMACIST_INFO_PAGE,
}

export const pharmacist_must_be_here: Question = {
  title: languages.pharmacistMustBeHere,
  titleCustomStyle: {
    fontSize: 36,
    lineHeight: "1.5",
  },
  imgUrl: cdn("/images/tlc_terminee_illustration.svg"),
  id: PATH.pharmacist_must_be_here,
  multipleReplies: false,
  subtitle: languages.pharmacistMustBeHereSubtitle_html,
  subtitleCustomStyle: {
    fontSize: 24,
    fontWeight: 500,
    lineHeight: "1.5",
  },
  ui: { view: "button" },
  replies: [
    {
      ui: { type: "default", view: "button" },
      title: languages.pharmacistMustBeHereBackToPathway,
      value: "pathway_choice_cancelled",
    },
    {
      ui: { type: "primary", view: "button" },
      title: languages.pharmacistMustBeHereProfessionalPresent,
      value: "pharmacist_present",
    },
  ],
}

export const DERMATO_QUESTIONS: Question[] = [
  dermato_overview_part1,
  dermato_overview_info,
  dermato_overview_part2,
  pharmacist_must_be_here,
  dermato_pharmacist_info,
  patient,
  exemption,
  dermato_reason,
  anamnesis_questions,
  pregnant,
  dermato_anamnesis_questions,
  dermato_problem_duration,
  dermato_questions,
  dermato_body_zone,
  dermato_phototype,
  dermato_symptoms,
  dermato_upload_documents,
  dermato_video_capture,
  dermato_recap,
  dermato_consent,
]
